export enum AssignGroupFormStep {
  GROUP = 'group',
  POSITION = 'position',
}
